import React, { useEffect, useState } from 'react';
import '../../assets/css/eventsReport.css';
import 'bootstrap/dist/css/bootstrap.css';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Line } from 'react-chartjs-2';
import { Chart } from 'react-google-charts';
import session from 'redux-persist/lib/storage/session';
import './CJ.css';
import Xarrow from 'react-xarrows';
import { getAllGoals, goalStats, getTopGoals, getGraphCJ } from './CJApi';
import Sankey from './Sankey';
import '../../assets/css/eventsReport.css';
let top = null;

function getTop() {
    return top;
}
function setTop(t) {
    top = t;
}

let currGoal = null;
let currprev = false;

let timeOutCalled = false;
function makeTimeOut(props, noOfDays) {
    setTimeout(() => {
        timeOutCalled = false;

        props.history.push('/admin/goals/detail', {
            goal: currGoal,
            prev: currprev,
            noOfDays: noOfDays,
        });
    }, 400);
}

function barGraphHandler(goal, prev, props, noOfDays) {
    if (goal) currGoal = goal;
    currprev = prev;
    if (!timeOutCalled) {
        timeOutCalled = true;
        makeTimeOut(props, noOfDays);
    }
}

function CJGraph(props) {

    //const [top, setTop] = useState(null)

    const [graph, setGraph] = useState([]);

    const [allgoals, setAllgoals] = useState([]);

    const [topGoalsProcessed, settopGoalsProcessed] = useState([]);

    const [rawGoals, setRawGoals] = useState([]);

    const [ggoalStats, setGoalStats] = useState({
        changeInCount: 0,
        changeInValue: 0,
        currentCount: 0,
        currentValue: 0,
        previousCount: 0,
        previousValue: 0,
    });

    const [noOfDays, setNoOfDays] = useState(7);

    const { role } = useSelector(
        (state) => state.userSetter
      );
      const [selected, setSel] = useState(role != 'publisher' ? 0 : 1);

    // const [noOfDays, setNoOfDays2] = useState(7);

    const graphHEIGHT = 500;
    let nodeSize = 40;
    let nodesMap = {};

    const processTopGoals = (data) => {
        setRawGoals(data);

        let g = [
            [
                'goal',
                'value',
                { role: 'style' },
                { role: 'tooltip' },
                { role: 'annotation' },
                'prev. value',
                { role: 'style' },
                { role: 'tooltip' },
                { role: 'annotation' },
            ],
        ];
        if (!data || !data.length) g.push(['', 0, '', '', '', 0, '', '', '']);
        data.forEach((d) => {

            if(role == "publisher"){
                g.push([
                    d.goalId.name,
                    d.currentCount,
                    'color:#92A3E3;',
                    `𝐂𝐨𝐮𝐧𝐭:${d.currentCount}`,
                    d.currentCount,
                    d.previousCount,
                    'color:#FFD2A6;stroke-width:25px;',
                    `𝐂𝐨𝐮𝐧𝐭:${d.previousCount}`,
                    d.previousCount,
                ]);
            }
            else{
            g.push([
                d.goalId.name,
                d.currentValue,
                'color:#92A3E3;',
                `𝐕𝐚𝐥𝐮𝐞:$${d.currentValue}\n𝐂𝐨𝐮𝐧𝐭: ${d.currentCount}`,
                d.currentCount,
                d.previousValue,
                'color:#FFD2A6;stroke-width:25px;',
                `𝐕𝐚𝐥𝐮𝐞:$${d.previousValue}\n𝐂𝐨𝐮𝐧𝐭: ${d.previousCount}`,
                d.previousCount,
            ]);
            }
        });
        settopGoalsProcessed(g);
    };

    useEffect(() => {
        var n = 7;
        if (sessionStorage.getItem('cj_noOfDays')) {
            n = sessionStorage.getItem('cj_noOfDays');

            try {
                n = parseInt(n);
                changeNoDays(n);
            } catch (e) { }
        }
        setNoOfDays(n || 7);
        async function fetchMyAPI() {
            getGraphCJ(n || noOfDays, null).then((gg) => {
                // .then(data=>{

                setGraph(gg);
            });

            getAllGoals(n || noOfDays).then((data) => {
                /// data =data.map(d=>{ return { name: d.goalId.name , id: d.goalId.id}} )
                setAllgoals(data);
                // /processTopGoals(data)
            });

            getTopGoals(n || noOfDays).then((data) => {
                processTopGoals(data);
            });

            goalStats(n || noOfDays).then((data) => {
                setGoalStats(data);
            });
        }
        fetchMyAPI();
    }, []);

    const changeNoDays = (v) => {
        sessionStorage.setItem('cj_noOfDays', v);
        setNoOfDays(v);
        getGraphCJ(v, null).then((gg) => {
            // .then(data=>{

            setGraph(gg);
        });

        getTopGoals(v).then((data) => {
            processTopGoals(data);
        });
        getAllGoals(v).then((data) => {
            setAllgoals(data);
        });
        goalStats(v).then((data) => {
            setGoalStats(data);
        });
    };
    const changeNoDays2 = (v) => {
        getTopGoals(v).then((data) => {
            processTopGoals(data);
        });

        goalStats(v).then((data) => {
            setGoalStats(data);
        });
    };

    const updateView = (id) => {
        if (id == -1) {
            id = null;
            setTop(null);
        }

        getGraphCJ(noOfDays, id).then((gg) => {
            // .then(data=>{

            setGraph(gg);
        });

        if (!id) {
            getTopGoals(noOfDays).then((data) => {
                processTopGoals(data);
            });
        } else {
            let goal = allgoals.filter((goals) => goals.goalId.id == id);
            processTopGoals(goal);
            setTop(goal[0]);
        }
    };

    return (
        <div>
            <div className='page_heading'>
                <h2>Journey</h2>
            </div>
            <div className='Rcontainer'>
                <div className='cj1 eBox'>
                    {graph && graph.length > 0 ? (
                        <Sankey graph={graph} height={graphHEIGHT} />
                    ) : (
                        <div className='event_conf' style={{ padding: '20% 25px' }}>
                            Assign credit and measure the impact of individual touchpoints
                            during the customer lifecycle. Learn more about how to create
                            <a
                                target='_blank'
                                href='https://kapitalwise.com/user-guide/tags/#utm'
                                style={{ marginRight: '2px' }}
                            >
                                UTM Links
                            </a>
                            and
                            <a
                                target='_blank'
                                href='https://www.kapitalwise.com/user-guide/tags/#goals'
                            >
                                Conversion Goals
                            </a>
                            .
                        </div>
                    )}

                    <div
                        style={{
                            border: 'none',
                            position: 'absolute',
                            bottom: '4px',
                            left: '4px',
                        }}
                        className='footer'
                    >
                        <select
                            value={noOfDays}
                            onChange={(e) => {
                                changeNoDays(e.target.value);
                            }}
                        >
                            <option value={7}>Last 7 days</option>
                            <option value={28}>Last 28 days</option>
                            <option value={90}>Last 90 days</option>
                        </select>

                        <select
                            style={{ marginRight: '15px' }}
                            onChange={(e) => {
                                updateView(e.target.value);
                            }}
                        >
                            <option value='-1'>Top 5 Goals </option>
                            {allgoals.map((g) => (
                                <option value={g.goalId.id}>{g.goalId.name}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className='cj2 eBox' style={{ maxWidth: '35%' }}>
                    <div
                        style={{
                            backgroundColor: 'rgba(220,220,220,0.1)',
                        }}
                    >
                        {role != 'publisher' &&<div
                            style={{
                                display: 'flex',
                                height: '30px',
                                display: 'flex',
                                width: '100%',
                                height: '60px',
                                marginTop: '2px',
                                paddingRight: '10px',
                                justifyContent: 'center',
                            }}
                        >
                            <h6
                                style={{ height: '50px', fontSize: '14px', flex: 1 }}
                                className={selected == 0 ? 'select selected' : 'select '}
                                onClick={(e) => {
                                    setSel(0);
                                }}
                            >
                                Value
                            </h6>
                            <h6
                                style={{ height: '50px', fontSize: '14px', flex: 1 }}
                                className={selected == 1 ? 'select selected' : 'select '}
                                onClick={(e) => {
                                    setSel(1);
                                }}
                            >
                                Count
                            </h6>
                        </div>
                        }

                        {selected == 0 ? (
                            <div
                                style={{
                                    display: 'flex',
                                    width: '100%',
                                    justifyContent: 'space-between',
                                    padding: '10px',
                                }}
                            >
                                <div className='cj_head_item'>
                                    <div style={{ display: 'flex' }}>
                                        <h3 className='cj_head_bg'>
                                            {ggoalStats ? ` $${ggoalStats.currentValue}` : ''}
                                        </h3>
                                    </div>

                                    <h6 className='cj_head_m'>Current Period</h6>
                                </div>

                                <div className='cj_head_item'>
                                    <div style={{ display: 'flex' }}>
                                        <h3 className='cj_head_bg'>
                                            {ggoalStats ? `$${ggoalStats.previousValue}` : ''}
                                        </h3>
                                    </div>
                                    <h6 className='cj_head_m'>Previous Period</h6>
                                </div>
                                <div className='cj_head_item'>
                                    <div style={{ display: 'flex' }}>
                                        {ggoalStats && Number(ggoalStats.changeInValue >= 0) ? (
                                            <div class='arrow-up'></div>
                                        ) : (
                                            <div class='arrow-down'></div>
                                        )}
                                        <h3 className='cj_head_bg' style={{ marginRight: '1px' }}>
                                            {ggoalStats && ggoalStats.changeInValue}%{' '}
                                        </h3>
                                    </div>
                                    <h6 className='cj_head_m'>Change</h6>
                                </div>
                            </div>
                        ) : (
                            <div
                                style={{
                                    display: 'flex',
                                    width: '100%',
                                    justifyContent: 'space-between',
                                    padding: '10px',
                                }}
                            >
                                <div className='cj_head_item'>
                                    <div style={{ display: 'flex' }}>
                                        <h3 className='cj_head_bg'>
                                            {ggoalStats ? `${ggoalStats.currentCount}` : ''}
                                        </h3>
                                    </div>

                                    <h6 className='cj_head_m'>Current Period</h6>
                                </div>

                                <div className='cj_head_item'>
                                    <div style={{ display: 'flex' }}>
                                        <h3 className='cj_head_bg'>
                                            {ggoalStats ? `${ggoalStats.previousCount}` : ''}
                                        </h3>
                                    </div>
                                    <h6 className='cj_head_m'>Previous Period</h6>
                                </div>
                                <div className='cj_head_item'>
                                    <div style={{ display: 'flex' }}>
                                        {ggoalStats && Number(ggoalStats.changeInCount) >= 0 ? (
                                            <div class='arrow-up'></div>
                                        ) : (
                                            <div class='arrow-down'></div>
                                        )}
                                        <h3 className='cj_head_bg' style={{ marginRight: '1px' }}>
                                            {ggoalStats && ggoalStats.changeInCount}%{' '}
                                        </h3>
                                    </div>
                                    <h6 className='cj_head_m'>Change</h6>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='cj-sep'> </div>
                    <h5 className='cj-info'>
                        click on the graph columns to view conversion details.
                    </h5>
                    <div style={{ display: 'flex', marginTop: '30px', padding: '5px' }}>
                        <h6
                            style={{
                                transform: 'rotate(90deg)',
                                transformOrigin: '0 22px',
                                whiteSpace: 'nowrap',
                                margin: 0,
                                width: '26px',
                                marginTop: '25px',
                            }}
                        >
                           { role!='publisher'? 'Conversion Value ($)': 'Count (No.)'}
                        </h6>
                        <Chart
                            width={'98%'}
                            height={'230px'}
                            chartType='ColumnChart'
                            loader={<div>Loading Chart</div>}
                            data={topGoalsProcessed}
                            legendToggle
                            options={{
                                tooltip: { isHtml: true },
                                bar: { groupWidth: '75%' },
                                legend: 'none',

                                chartArea: {
                                    // leave room for y-axis labels
                                    width: '84%',
                                    height: '74%',
                                },
                                axes: {
                                    x: {
                                        0: { side: 'top', label: 'Percentage' }, // Top x-axis.
                                    },
                                },

                            }}
                            chartEvents={[
                                {
                                    eventName: 'ready',
                                    callback: ({ chartWrapper, google }) => {
                                        const chart = chartWrapper.getChart();

                                        google.visualization.events.addListener(
                                            chart,
                                            'onmouseover',
                                            (e) => {
                                                console.info('hover', e.targetID);
                                                document.body.style.cursor = 'pointer';
                                            }
                                        );
                                        google.visualization.events.addListener(
                                            chart,
                                            'onmouseout',
                                            (e) => {
                                                console.info('leve', e.targetID);
                                                document.body.style.cursor = 'default';
                                            }
                                        );
                                        google.visualization.events.addListener(
                                            chart,
                                            'click',
                                            (e) => {
                                                if (!e) return;

                                                let goalIndex = e.targetID.split('#');
                                                if (goalIndex[0] == 'bar') {
                                                    let prev = goalIndex[1] == 1 ? true : false;

                                                    goalIndex = parseInt(goalIndex[2]);

                                                    if (getTop()) {
                                                        barGraphHandler(
                                                            getTop(),
                                                            prev,
                                                            props.props,
                                                            noOfDays
                                                        );
                                                    } else if (rawGoals[goalIndex]) {
                                                        barGraphHandler(
                                                            rawGoals[goalIndex],
                                                            prev,
                                                            props.props,
                                                            noOfDays
                                                        );
                                                    }
                                                }
                                            }
                                        );
                                    },
                                },
                            ]}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            margin: '20px',
                        }}
                    >
                        <div>
                            <span
                                style={{
                                    paddingLeft: '5px',
                                    backgroundColor: '#92A3E3',
                                    borderRadius: '50%',
                                    /* width: 5px; */
                                    paddingRight: '12px',
                                    margin: '5px',
                                }}
                            ></span>{' '}
                            Current Period{' '}
                        </div>
                        <div>
                            <span
                                style={{
                                    paddingLeft: '5px',
                                    backgroundColor: '#FFD2A6',
                                    borderRadius: '50%',
                                    /* width: 5px; */
                                    paddingRight: '12px',
                                    margin: '5px',
                                }}
                            ></span>{' '}
                            Previous Period{' '}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CJGraph;
